/**************************************************************************************************/
/*   File: /src/app/shared/models/bbox.ts                                                  */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Wednesday May 29th 2019                                                        */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The bbox
 */
export class Bbox {
    /**
     * The is empty boolean
     * @type {boolean}
     */
    isEmpty: boolean;
    /**
     * The minX
     * @type {number}
     */
    minX: number;
    /**
     * The maxX
     * @type {number}
     */
    maxX: number;
    /**
     * The minY
     * @type {number}
     */
    minY: number;
    /**
     * The max y
     * @type {number}
     */
    maxY: number;
}